import { Component, OnInit } from '@angular/core';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';

@Component({
	selector: 'app-blank-page-template',
	templateUrl: './blank-page-template.component.html',
	styleUrls: ['./blank-page-template.component.scss'],
})
export class BlankPageTemplateComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}
}
